// import { ColorBends } from '../../../shared/ui';
// import { COLOR_BENDS_CONFIG } from '../../../shared/lib';
import { ComingSoonToast, useComingSoonToast } from '../../../features';
import { Header, Footer, HeroSection, FeaturesStrip, MockupsSection } from '../../../widgets';
import './HomePage.css';

export function HomePage() {
  const { showToast, triggerToast } = useComingSoonToast();

  return (
    <div className="App">
      {/* Full-page ColorBends Background */}
      {/* <div className="background-animation">
        <ColorBends
          colors={COLOR_BENDS_CONFIG.colors}
          rotation={COLOR_BENDS_CONFIG.rotation}
          speed={COLOR_BENDS_CONFIG.speed}
          scale={COLOR_BENDS_CONFIG.scale}
          frequency={COLOR_BENDS_CONFIG.frequency}
          warpStrength={COLOR_BENDS_CONFIG.warpStrength}
          mouseInfluence={COLOR_BENDS_CONFIG.mouseInfluence}
          parallax={COLOR_BENDS_CONFIG.parallax}
          noise={COLOR_BENDS_CONFIG.noise}
          style={{ width: '100%', height: '100%' }}
        />
      </div> */}

      {/* Coming Soon Toast */}
      <ComingSoonToast visible={showToast} />

      {/* Content Wrapper */}
      <div className="content-wrapper">
        <Header />
        
        <HeroSection />
        
        <FeaturesStrip />
        
        <MockupsSection />
        
        <Footer onSocialClick={triggerToast} />
      </div>
    </div>
  );
}

export default HomePage;


